import React, { useState, useCallback, useMemo } from "react"

import { ErrorProps } from "components/AppErrorModal"
import { ErrorContext } from "context/ErrorContext"

export const ErrorProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [error, setError] = useState<ErrorProps | null>(null)

  const handleError = useCallback(
    ({ title, message, action, log }: ErrorProps) => {
      setError({ title, message, action, log })
    },
    []
  )

  const clearError = useCallback(() => {
    setError(null)
  }, [])

  const contextValue = useMemo(
    () => ({ error, handleError, clearError }),
    [clearError, error, handleError]
  )

  return (
    <ErrorContext.Provider value={contextValue}>
      {children}
    </ErrorContext.Provider>
  )
}
